import React, { useEffect, useRef, useState } from 'react'
import { CToast, CToastBody, CToastClose, CToastHeader, CToaster } from '@coreui/react-pro'
import { subscribeToasts } from '../utils/appToasts'

const AppToaster = () => {
  const toaster = useRef()
  const [toast, addToast] = useState(0)

  useEffect(() => {
    const unsubscribe = subscribeToasts(({ color, title, message, delay }) => {
      addToast(
        <CToast delay={delay} color={color} className="text-white" animation>
          <CToastHeader>
            <strong className="me-auto">{title}</strong>
            <CToastClose className="me-2 m-auto" white />
          </CToastHeader>
          <CToastBody>{message}</CToastBody>
        </CToast>,
      )
    })

    return unsubscribe
  }, [])

  return <CToaster ref={toaster} push={toast} placement="top-end" />
}

export default AppToaster
